<template>
  <div class="center">
    <!-- 条件筛选框 -->
    <div class="waitingcom_title">
      <!-- 表单 -->
      <el-form
        label-width="100px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="公告状态：">
          <el-select
            v-model="formLabelAlign.noticeStatus"
            placeholder="全部"
            @change="handleQuery"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in noticeStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="发布者：">
          <el-input
            v-model.trim="formLabelAlign.publisher"
            placeholder="请输入发布者"
          ></el-input
        ></el-form-item>

        <el-form-item label="公告开始时间：">
          <el-date-picker
            v-model="formLabelAlign.addTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <!-- 搜索按钮 -->
      <div class="query_btn">
        <el-button
          @click="handleQuery"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetQuery"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          >重置</el-button
        >
      </div>
    </div>

    <!-- 列表全局按钮 -->
    <div class="oper_box">
      <el-button @click="switchBasisPage('add')" v-if="$root.$hasbtn('添加公告')" plain>
        <i class="iconfont icon-action-add-hover"></i>添加公告</el-button
      >
      <el-button
      v-if="$root.$hasbtn('批量删除')"
        @click="
          hintDialogVisible = true;
          isBatchDelete = true;
          hintDialogTitle = '批量删除公告';
          hintDialogContent = '确定要将选定公告批量删除吗？删除后不可还原';
          deleteBuried('indexArr');
        "
        :disabled="multiple"
        plain
      >
        <i class="iconfont icon-batch-shanchu"></i>批量删除</el-button
      >
    </div>

    <!-- 表格内容 -->
    <div class="notice_table" v-loading="isLoading">
      <el-table
        ref="table"
        :data="getData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @row-click="stepsListRowClick"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column
          type="selection"
          width="60"
          align="center"
          :reserve-selection="true"
        ></el-table-column>

        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="公告名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.NoticeName }}
          </template>
        </el-table-column>

        <el-table-column label="公告开放时间" align="center">
          <template slot-scope="scope">
            {{
              scope.row.BeginTime == null || scope.row.EndTime == null
                ? null
                : $moment(scope.row.BeginTime).format("YYYY/MM/DD HH:mm") +
                  "-" +
                  $moment(scope.row.EndTime).format("YYYY/MM/DD HH:mm")
            }}
          </template>
        </el-table-column>

        <el-table-column label="公告状态" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.State == 0" style="color: #ffa200">待发布</p>
            <p v-else-if="scope.row.State == 1" style="color: #00d299">
              已发布
            </p>
            <p v-else-if="scope.row.State == 2" style="color: #999999">
              已过期
            </p>
            <p v-else>未知状态</p>
          </template>
        </el-table-column>

        <el-table-column label="添加时间" align="center">
          <template slot-scope="scope">
            {{
              scope.row.CreateTime == null
                ? null
                : $moment(scope.row.CreateTime).format("YYYY/MM/DD HH:mm")
            }}
          </template>
        </el-table-column>

        <el-table-column label="发布者" align="center">
          <template slot-scope="scope">
            {{ scope.row.Publisher }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
              v-if="$root.$hasbtn('详情')"
                @click.stop="switchBasisPage('detail', scope.row)"
                type="text"
                size="small"
                >详情</el-button
              >
              <el-button
              v-if="$root.$hasbtn('删除')"
                @click.stop="
                  hintDialogVisible = true;
                  isDetele = true;
                  hintDialogTitle = '删除公告';
                  hintDialogContent =
                    '确定将名为 ' +
                    scope.row.NoticeName +
                    ' 的公告删除吗？删除后不可还原';
                  rowData = scope.row;
                  deleteBuried('index');
                "
                type="text"
                size="small"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="total"
          class="pagination"
        ></el-pagination>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <div class="hintDialogBox">
      <el-dialog
        :title="hintDialogTitle"
        :visible.sync="hintDialogVisible"
        width="30%"
        @closed="hintDialogClosed"
      >
        <span>{{ hintDialogContent }}</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="hintDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="hintDialogSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
import noticeApi from "@/api/notice";
export default {
  props: ["changes"],
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      // 条件筛选框全局定义
      labelPosition: "right",
      formLabelAlign: {
        noticeStatus: "",
        publisher: "",
        addTime: [],
      },
      noticeStatusList: [
        {
          value: "0",
          label: "待发布",
        },
        {
          value: "1",
          label: "已发布",
        },
        {
          value: "2",
          label: "已过期",
        },
      ],
      // 列表全局按钮
      multiple: true,
      // 提示弹窗唤起
      hintDialogVisible: false,
      hintDialogTitle: "",
      hintDialogContent: "",
      isDetele: false,
      isBatchDelete: false,
      // 表格内容全局定义
      isLoading: true,
      multipleSelectionIds: [],
      multipleSelection: [],
      multipleSelectionCount: 0,
      getDataCondition: {
        noticeStatus: "",
        publisher: "",
        addBeginTime: "",
        addEndTime: "",
      },
      getData: [],
      currentPage: 1,
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 0,
      // 详情按钮点击需要的参数
      rowData: {},
      pageType: "",
    };
  },
  methods: {
    // 搜索
    handleQuery() {
      this.Buriedpoint(
        { code: "Notices:notice:search", parent_code: "Notices:notice" },
        "statetime"
      );
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      if (this.formLabelAlign.noticeStatus) {
        this.getDataCondition.noticeStatus = this.formLabelAlign.noticeStatus;
      } else {
        this.getDataCondition.noticeStatus = "";
      }
      if (this.formLabelAlign.publisher) {
        this.getDataCondition.publisher = this.formLabelAlign.publisher;
      } else {
        this.getDataCondition.publisher = "";
      }
      if (this.formLabelAlign.addTime.length > 0) {
        this.getDataCondition.addBeginTime = this.formLabelAlign.addTime[0];
        this.getDataCondition.addEndTime = this.formLabelAlign.addTime[1];
      } else {
        this.getDataCondition.addBeginTime = null;
        this.getDataCondition.addEndTime = null;
      }
      this.getAllNotice();
    },
    // 重置
    resetQuery() {
      this.Buriedpoint(
        { code: "Notices:notice:rest", parent_code: "Notices:notice" },
        "statetime"
      );
      this.formLabelAlign = {
        noticeStatus: "",
        publisher: "",
        addTime: [],
      };
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      this.getDataCondition.noticeStatus = "";
      this.getDataCondition.publisher = "";
      this.getDataCondition.addBeginTime = "";
      this.getDataCondition.addEndTime = "";
      this.isLoading = true;
      this.getAllNotice();
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    // 基本请求参数工具
    baseReqParamUtils(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    // 获取公告列表
    async getAllNotice() {
      this.isLoading = true;
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.pageIndex = this.currentPage - 1;
      reqParam.eachPageNum = this.pageSize;

      reqParam.noticeStatus = this.getDataCondition.noticeStatus;
      reqParam.publisher = this.getDataCondition.publisher;
      if (this.getDataCondition.addBeginTime) {
        reqParam.addBeginTime = this.$moment(
          this.getDataCondition.addBeginTime
        ).format("YYYY-MM-DD HH:mm:ss");
      }
      if (this.getDataCondition.addEndTime) {
        reqParam.addEndTime = this.$moment(
          this.getDataCondition.addEndTime
        ).format("YYYY-MM-DD HH:mm:ss");
      }

      console.log(reqParam, "获取公告列表请求数据");
      const { data } = await noticeApi.getAllNotice(reqParam);
      console.log(data, "获取公告列表返回数据");
      if (data.Status == 200) {
        this.getData = data.Data.data;
        this.total = data.Data.count;
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      } else {
        this.$message.error(data.Data);
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 表格多选框改变时触发
    handleSelectionChange(rows) {
      // 初始化全局表格多选框
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      // 将数据存入
      rows.forEach((row) => {
        this.multipleSelectionIds.push(row.NoticeID);
      });
      this.multipleSelection = rows;
      this.multipleSelectionCount = this.multipleSelection.length;
      // 全局按钮样式配置
      this.multiple = !this.multipleSelection.length;
      // 日志输出
      // console.log(this.multipleSelectionIds,'<<=====multipleSelectionIds');
      // console.log(this.multipleSelection,'<<=====multipleSelection');
      // console.log(this.multipleSelectionCount,'<<=====multipleSelectionCount');
    },
    // 勾选当前行激活check
    stepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.NoticeID;
    },
    // 每页大小改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.isLoading = true;
      this.getAllNotice();
    },
    // 切换页数后触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.isLoading = true;
      this.getAllNotice();
    },
    // 提示弹窗关闭触发
    hintDialogClosed() {
      this.isDetele = false;
      this.isBatchDelete = false;
    },
    // 提示弹窗提交按钮
    async hintDialogSubmit() {
      if (this.isDetele) {
        console.log("删除公告...");
        this.deleteNotices("single", this.rowData);
      }
      if (this.isBatchDelete) {
        console.log("批量删除公告...");
        this.deleteNotices("batch");
      }
    },
    //删除埋点
    deleteBuried(text) {
      if (text === "index") {
        this.Buriedpoint(
          { code: "Notices:notice:delete", parent_code: "Notices:notice" },
          "statetime"
        );
      } else if (text === "indexArr") {
         this.Buriedpoint(
          { code: "Notices:notice:batchDelete", parent_code: "Notices:notice" },
          "statetime"
        );
      }
    },
    // 切换到基础信息页面
    switchBasisPage(key, row) {
      this.rowData = {};
      switch (key) {
        case "add":
          break;
        case "edit":
          this.rowData = row;
          break;
        case "detail":
          this.rowData = row;
          break;
        default:
          // this.$message.error("没有找到页面类型");
          return;
      }
      this.pageType = key;
      if (key === "add") {
        this.$parent.indexState = 0; // 新增
        localStorage.setItem("isreload", true);
        this.Buriedpoint({
          code: "Notices:notice:add",
          parent_code: "Notices:notice",
        });
      } else if (key === "detail") {
        this.$parent.indexState = 1; // 详情
        localStorage.setItem("isreload", true);
        this.Buriedpoint({
          code: "Notices:notice:detail",
          parent_code: "Notices:notice",
        });
      }
      this.changes(1);

      console.log("切换到" + key + "基础页面...");
      console.log(this.rowData, "<<===rowData");
    },
    // 删除公告（可批量）
    async deleteNotices(key, row) {
      let msg = "";
      const reqParam = this.baseReqParamUtils(new Object());
      if (key == "single") {
        reqParam.nIDArr = `[${row.NoticeID}]`;
        msg = "删除公告成功";
      } else if (key == "batch") {
        reqParam.nIDArr = `[${this.multipleSelectionIds}]`;
        msg = "批量删除公告成功";
      }
      console.log(reqParam, "删除公告请求数据");
      const { data } = await noticeApi.deleteNotice(reqParam);
      console.log(data, "删除公告返回数据");
      if (data.Status == 200) {
        this.$message.success(msg);
        this.hintDialogVisible = false;
        this.getAllNotice();
      } else {
        this.$message.error(data.Data);
      }
    },
  },
  created() {
    this.stateArr = [];
    this.getAllNotice();
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang='scss' scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

// 条件筛选框css
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  // justify-content: space-between;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 88px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .el-form {
    display: flex;
    ::v-deep .el-form-item:nth-child(3) {
      .el-form-item__content {
        margin-left: 144px !important;
      }
      .el-form-item__label {
        width: 120px !important;
      }
    }
    ::v-deep .el-form-item__content {
      margin-left: 115px !important;
    }
    ::v-deep .el-input > .el-input__inner {
      width: 168px;
    }
  }
  .query_btn {
    margin: 0;
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}

// 列表全局按钮css
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 104px;
    margin-left: 0px;
    margin-right: 24px;
  }
  .el-button:nth-child(2) {
    background: #e54d4d;
    width: 104px;
    margin-left: 0px;
    margin-right: 24px;
    span > i {
      font-size: 16px !important;
      margin-right: 5px;
    }
  }
}

// 表格内容css
.notice_table {
  margin-top: 24px;
  padding: 0px 24px;
  min-height: 560px;
}

.operation_box {
  width: 250px;
  text-align: center;
  margin: 0 auto;
  .el-button {
    font-size: 16px;
    margin-left: 0px;
    margin-right: 25px;
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}

// 分页
.foot_box {
  position: relative;
  height: 88px;
  .foot_pagetions {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
    .pagination {
      ::v-deep .el-pager {
        li {
          border: 1px solid #d9d9d9;
          margin-right: 8px;
          &.active {
            color: #ffffff;
            background-color: #409eff;
            border: none;
          }
        }
      }
      ::v-deep .el-pagination__jump {
        margin: 0px 10px 0px 0px !important;
      }
      // ::v-deep .el-pagination__jump {
      //   &::before {
      //     content: "10条/页";
      //     width: 82px;
      //     border: 1px solid #d9d9d9;
      //     height: 28px;
      //     border-radius: 2px;
      //     text-align: center;
      //     display: inline-block;
      //     margin-right: 8px;
      //     cursor: pointer;
      //   }
      // }
    }
  }
}

::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

// dialog提示弹窗css
.hintDialogBox {
  // dialog整体样式
  ::v-deep .el-dialog {
    width: 421px !important;
    border-radius: 5px 5px 5px 5px;
    background: #ffffff;
    opacity: 1;
    // 弹框头部样式
    .el-dialog__header {
      height: 60px;
      background: linear-gradient(
        180deg,
        #64b5ff 0%,
        rgba(199, 228, 255, 1) 100%
      );
      opacity: 1;
      border-radius: 5px 5px 0px 0px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    // 弹框身体样式
    .el-dialog__body {
      text-align: center;
    }
    // 弹框底部样式
    .dialog-footer {
      text-align: center;
      .el-button {
        margin-right: 50px;
      }
      .el-button:nth-child(1) {
        background: #eeeeee;
        opacity: 1;
        border-radius: 4px;
      }
      .el-button:nth-child(2) {
        background: #1890ff;
        opacity: 1;
        border-radius: 4px;
      }
    }
  }
}
</style>